// extracted by mini-css-extract-plugin
export var actionText = "_jn-4";
export var container = "_jn-0";
export var leftSection = "_jn-1";
export var rightSection = "_jn-2";
export var settingsButton = "_jn-6";
export var settingsIcon = "_jn-7";
export var shortcut = "_jn-5";
export var shortcutGroup = "_jn-3";